define.alias("shared/components/shared/plan-recommendation/steps/role", "calendar/components/shared/plan-recommendation/steps/role");